// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_Sy","legend":"e_Ty","legendContent":"e_Uy","contentWrapper":"e_Vy","fieldsetContent":"e_Wy"};